import React from "react";
import HeroCard from "@/components/heroCard";
import { HERO_CONSTANTS } from "./constants";

const Hero = () => {
  return (
    <HeroCard backgroundImage="/migrationToMost/header-vmware.png" {...HERO_CONSTANTS} />
  );
};

export default Hero;
